import { useAuth } from '@hooks/useAuth';
import { ReactElement, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

interface LtiLoginProps {
  loader: ReactElement;
}

export default function LtiLogin({ loader }: LtiLoginProps) {
  const [searchParams] = useSearchParams();
  const loginHint = searchParams.get('login_hint');
  const returnTo = searchParams.get('r') || '/';
  const { login } = useAuth(false, 'internal');
  useEffect(() => {
    login({
      appState: { returnTo },
      connection: 'lti',
      login_hint: loginHint ?? undefined
    });
  }, [loginHint, login, returnTo]);
  return loader;
}
